import AddServiceUpdateModal from "@/admin/components/add-serviceUpdateModal/AddServiceUpdateModal";
import AdminWrapper from "@/admin/components/addmin-wrapper/AdminWrapper";
import DocumentComp from "@/admin/components/document/DocumentComp";
import ServiceUpdateComp from "@/admin/components/service-update-comp/ServiceUpdateComp";
import Service from "@/admin/components/service/Service";
import DataNotFound from "@/components/data-not-found/DataNotFound";
import Spinner from "@/components/spinner/Spinner";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import useGetApiReq from "@/hooks/useGetApiReq";
import { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import parse from "html-react-parser";
import AssignPartnerModal from "@/admin/components/AssignPartnerModal";

const ClientServiceDetails = () => {
  const { res, fetchData, isLoading } = useGetApiReq();

  const [client, setClient] = useState("");
  const [service, setService] = useState("");
  const [updates, setUpdates] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [isAddServiceUpdateModalOpen, setIsAddServiceUpdateModalOpen] =
    useState(false);
  const [clientService, setClientService] = useState("");
  const [isAssignClientModalOpen, setIsAssignClientModalOpen] = useState(false);

  const params = useParams();
  const icon = `${import.meta.env.VITE_IMG_URL}/${service?.icon}`;

  const getServiceDetail = async () => {
    fetchData(`/admin/get-client-service-update-details/${params?.serviceId}`);
  };

  useEffect(() => {
    getServiceDetail();
  }, []);

  useEffect(() => {
    if (res?.status === 200 || res?.status === 201) {
      console.log("service detail", res?.data);
      setService(res?.data?.info?.serviceInfo);
      setClient(res?.data?.info?.clientInfo);
      setUpdates(res?.data?.info?.updates);
      setDocuments(res?.data?.info?.documents);
      setClientService(res?.data?.info?.clientService);
    }
  }, [res]);

  const navigate = useNavigate();

  return (
    <AdminWrapper>
      <div>
        {clientService?.paymentStatus === "due" && (
          <div className="mt-1 mb-3 text-white flex justify-between items-center bg-gray-800 px-2 py-2">
            The Client have not paid the cost of this service yet.
            {clientService?.paymentStatus === "due" && (
              <span>Due Amount : {clientService?.cost}</span>
            )}
          </div>
        )}
        <div className="section-heading-container">
          <h1 className="section-heading">Service Details</h1>
          <div className="flex gap-3 items-center">
            {clientService?.serviceStatus === "unassigned" && (
              <Button onClick={() => setIsAssignClientModalOpen(true)}>
                Assign Partner
              </Button>
            )}
            <Button onClick={() => setIsAddServiceUpdateModalOpen(true)}>
              Add Service Update
            </Button>
          </div>
        </div>
        <Table className="mt-4 glass-header !border-white !border-2 !shadow-none">
          <TableHeader>
            <TableRow className="text-lg">
              <TableHead>Icon</TableHead>
              <TableHead>Name</TableHead>
              <TableHead>Category</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow className="glass-header !border-white !border-2 !shadow-none">
              <TableCell>
                <div
                  onClick={() =>
                    navigate(`/admin/categories/${service?._id}`, {
                      state: service,
                    })
                  }
                  className="w-12 cursor-pointer h-12 rounded-full bg-slate-500"
                >
                  <img
                    className="w-full h-full rounded-full"
                    src={icon}
                    alt=""
                  />
                </div>
              </TableCell>
              <TableCell>
                <h3
                  onClick={() =>
                    navigate(`/admin/categories/${service?._id}`, {
                      state: service,
                    })
                  }
                  className="text-lg cursor-pointer font-semibold"
                >
                  {service?.name}
                </h3>
              </TableCell>
              <TableCell>{service?.categoryId?.name}</TableCell>
            </TableRow>
            {/* <Service edit={={() => setIsAddServiceUpdateModalOpen(true)}>Add Service Update</Button>
                    </div>
                </div>
                <Table className="mt-4">
                    <TableHeader>
                        <TableRow className="text-lg">
                            <TableHead>Icon</TableHead>
                            <TableHead>Name</TableHead>
                            <TableHead>Category</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        <TableRow className="">
                            <TableCell>
                                <div onClick={() => navigate(`/admin/categories/${service?._id}`, { state: service })} className="w-12 cursor-pointer h-12 rounded-full bg-slate-500">
                                    <img className="w-full h-full rounded-full" src={icon} alt="" />
                                </div>
                            </TableCell>
                            <TableCell>
                                <h3 onClick={() => navigate(`/admin/categories/${service?._id}`, { state: service })} className="text-lg cursor-pointer font-semibold">{service?.name}</h3>
                            </TableCell>
                            <TableCell>{service?.categoryId?.name}</TableCell>
                        </TableRow>
                        {/* <Service edit={false} service={service} /> */}
          </TableBody>
        </Table>
        <p className="max-[560px]:text-sm">
          {service?.description && parse(service?.description)}
        </p>

        <h2 className="text-xl font-semibold mb-3 mt-14">Client Details</h2>

        <Table className="glass-header !border-white !border-2 !shadow-none">
          <TableHeader>
            <TableRow className="text-lg">
              <TableHead>Name</TableHead>
              <TableHead>Phone</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Address</TableHead>
              <TableHead>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow className="glass-header !border-white !border-2 !shadow-none">
              <TableCell>{`${client?.name?.first} ${client?.name?.last}`}</TableCell>
              <TableCell>{client?.phone}</TableCell>
              <TableCell>{client.email}</TableCell>
              <TableCell>{`${client?.address?.addressLine} ${client?.address?.city}, ${client?.address?.state}, ${client?.address?.pinCode}`}</TableCell>
              <TableCell>
                <FaEye
                  onClick={() => navigate(`/admin/clients/${client?._id}`)}
                  size={24}
                  cursor={"pointer"}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <div className="flex justify-between items-center gap-3 mb-3 mt-14">
          <h2 className="text-xl font-semibold">Service Updates</h2>
          {updates.length > 0 && (
            <button
              onClick={() =>
                navigate(
                  `/admin/clients/${params?.clientId}/service/${params?.serviceId}/updates`,
                  { state: updates }
                )
              }
              className="bg-gray-800 ml-2 flex gap-3 items-center hover:bg-gray-800 text-white rounded-md px-4 py-1"
            >
              View All
            </button>
          )}
        </div>

        <Table className="mt-4 glass-header !border-white !border-2 !shadow-none">
          <TableHeader>
            <TableRow className="text-lg">
              <TableHead>Client Name</TableHead>
              {/* <TableHead>Status</TableHead> */}
              <TableHead>Date</TableHead>
              <TableHead>Document</TableHead>
              <TableHead>Description</TableHead>
              <TableHead>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {updates?.map((update, index) => {
              if (index <= 4) {
                return (
                  <ServiceUpdateComp
                    key={update?._id}
                    update={update}
                    getServiceUpdates={getServiceDetail}
                  />
                );
              }
            })}
          </TableBody>
        </Table>

        {updates.length === 0 && isLoading && <Spinner size={30} />}

        {updates.length === 0 && !isLoading && (
          <DataNotFound name={"Service Updates"} />
        )}

        <div className="flex justify-between items-center gap-4 mb-3 mt-14">
          <h2 className="text-xl font-semibold">Service Documents</h2>
          {documents.length > 0 && (
            <button
              onClick={() =>
                navigate(
                  `/admin/clients/${params?.clientId}/service/${params?.serviceId}/documents`,
                  { state: documents }
                )
              }
              className="bg-gray-800 ml-2 flex gap-3 items-center hover:bg-gray-800 text-white rounded-md px-4 py-1"
            >
              View All
            </button>
          )}
        </div>

        {documents.length === 0 && isLoading && <Spinner size={30} />}

        {documents.length === 0 && !isLoading && (
          <DataNotFound name={"Documents"} />
        )}

        <div className="grid max-[640px]:place-items-center grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-4">
          {documents?.map((document, index) => {
            if (index <= 4) {
              return <DocumentComp key={document._id} myDocument={document} />;
            }
          })}
        </div>

        {isAddServiceUpdateModalOpen && (
          <AddServiceUpdateModal
            isAddServiceUpdateModalOpen={isAddServiceUpdateModalOpen}
            setIsAddServiceUpdateModalOpen={setIsAddServiceUpdateModalOpen}
            getServiceUpdates={getServiceDetail}
            serviceId={service?._id}
            clientId={client?._id}
          />
        )}

        {isAssignClientModalOpen && (
          <AssignPartnerModal
            isAssignClientModalOpen={isAssignClientModalOpen}
            setIsAssignClientModalOpen={setIsAssignClientModalOpen}
            clientService={clientService}
            getServiceDetail={getServiceDetail}
          />
        )}
      </div>
    </AdminWrapper>
  );
};

export default ClientServiceDetails;
